import {CACHE_TIME_24H, CachedContent, getFutureTime} from "./cachedContent";

export class CacheUtil {
  /**
   * The underlying SuiClient instance used for making RPC calls to the Sui network.
   * This client is used to interact with the Sui blockchain and execute various operations.
   */
  private readonly _cache: Record<string, CachedContent> = {}

  private static instance: CacheUtil;

  private constructor() {}

  static getInstance() {
    if (!this.instance) {
      this.instance = new CacheUtil();
    }
    return this.instance;
  }
  /**
   * Updates the cache for the given key.
   *
   * @param key The key of the cache entry to update.
   * @param data The data to store in the cache.
   * @param time The time in minutes after which the cache entry should expire.
   */
  public updateCache(key: string, data: any, time = CACHE_TIME_24H): void {
    let cacheData = this._cache[key]
    if (cacheData) {
      cacheData.overdue_time = getFutureTime(time)
      cacheData.value = data
    } else {
      cacheData = new CachedContent(data, getFutureTime(time))
    }
    this._cache[key] = cacheData
  }

  /**
   * Gets the cache entry for the given key.
   *
   * @param key The key of the cache entry to get.
   * @param force_refresh Whether to force a refresh of the cache entry.
   * @returns The cache entry for the given key, or undefined if the cache entry does not exist or is expired.
   */
  public getCache<T>(key: string, force_refresh = false): T | undefined {
    const cacheData = this._cache[key]
    const isValid = cacheData?.isValid()
    if (!force_refresh && isValid) {
      return cacheData.value as T
    }
    if (!isValid) {
      delete this._cache[key]
    }
    return undefined
  }
}
